module.exports = "<p *ngFor=\"let graphData of surveyGraphsData\" style=\"width: 75%;\">\r\n  <p-chart type=\"horizontalBar\" [data]=\"graphData\" [options]=\"graphData.options\"></p-chart>\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/surveys/survey-result/survey-result.component.html
// module id = ./src/app/surveys/survey-result/survey-result.component.html
// module chunks = surveys.module